import { getMarketContext } from "../config/market-context.js";
import { translateDom } from "./dom-translator.js";
import { getI18n } from "./index.js";
import nlCatalog from "../catalog/catalog.nl.json";
import deCatalog from "../catalog/catalog.de.json";
import { bindAddToCartPrice } from "../helpers/add-to-cart-button.js";

const catalogs = { nl: nlCatalog, de: deCatalog };

export async function initializeI18n(context) {
  const baseContext = context || getMarketContext();
  const marketContext = Object.freeze({
    ...baseContext,
    catalog: Object.freeze(catalogs[baseContext.market] || {}),
  });
  let translator;

  try {
    translator = getI18n(marketContext);
    document.documentElement.lang = marketContext.locale.split("-")[0];
    translateDom(
      document,
      translator.t,
      translator.formatCurrency,
      marketContext,
    );
    bindAddToCartPrice(document, translator.t);

    return { marketContext, ...translator };
  } finally {
    document.documentElement.removeAttribute("data-i18n-pending");
  }
}
